import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Button, Popconfirm, Tag } from "antd";
import {
  DeleteFilled,
  QuestionCircleOutlined,
  EditFilled,
} from "@ant-design/icons";
import usersActions from "../../../redux/users/actions";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import AdminUsersEditModal from "../../../components/Admin/AdminUsersComponents/AdminUsersEditModal";
import AdminUsersSearchInput from "../../../components/Admin/AdminUsersComponents/AdminUsersSearchInput";
import "./index.css";

const Users = () => {
  const dispatch = useDispatch();
  const { users, reloadUsers } = useSelector((state) => state.usersReducer);
  const { getUsersRequest, deleteUser, getAllAccess } = usersActions;
  const [user, setUser] = useState({});
  const [openAdminUserEditModal, setOpenAdminUserEditModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    dispatch(getUsersRequest());
    dispatch(getAllAccess());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadUsers]);

  const onlyCheckedOrganizations = (array) => {
    return array?.filter((x) => x.isChecked === true);
  };

  const saveSearchValue = (data) => {
    setSearchValue(data);
  };

  const columns = [
    {
      title: "Име",
      dataIndex: "firstName",
      rowKey: "firstName",
      key: "firstName",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Фамилия",
      dataIndex: "lastName",
      rowKey: "lastName",
      key: "lastName",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      rowKey: "email",
      key: "email",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Организации",
      dataIndex: "organizations",
      rowKey: "organizations",
      render: (text, record) => (
        <>
          {record?.role === 1 ? (
            <Tag
              bordered={false}
              color="red"
              className="admin-users-table-organizations-tags"
            >
              Админ акаунт
            </Tag>
          ) : onlyCheckedOrganizations(record?.organizations)?.length >= 5 &&
            onlyCheckedOrganizations(record?.organizations)?.length !== 0 ? (
            <>
              {onlyCheckedOrganizations(record?.organizations)
                ?.slice(0, 5)
                ?.map((org) => (
                  <Tag
                    key={org.id}
                    bordered={false}
                    color="blue"
                    className="admin-users-table-organizations-tags"
                  >
                    {org.name}
                  </Tag>
                ))}
              <Tag
                bordered={false}
                color="blue"
                className="admin-users-table-organizations-tags"
              >
                ...още
              </Tag>
            </>
          ) : (
            onlyCheckedOrganizations(record?.organizations)?.map((org) => (
              <Tag
                key={org.id}
                bordered={false}
                color="blue"
                className="admin-users-table-organizations-tags"
              >
                {org.name}
              </Tag>
            ))
          )}
        </>
      ),
    },
    {
      title: "Права",
      dataIndex: "accessInformation",
      rowKey: "accessInformation",
      render: (accessInformation) => (
        <span>
          {accessInformation?.some((access) => access.name === "Admin") ? (
            <span className="admin-user-table-is-admin">A</span>
          ) : (
            ""
          )}
        </span>
      ),
    },
    {
      title: "Последен вход",
      dataIndex: "lastLogin",
      rowKey: "lastLogin",
      render: (text) =>
        text !== "0001-01-01T00:00:00" && (
          <span>{text.replace("T", " ").split(".")[0]}</span>
        ),
    },
    {
      title: "Редактирай",
      dataIndex: "Edit",
      rowKey: "edit",
      render: (text, record) => (
        <Button
          onClick={() => {
            setOpenAdminUserEditModal(true);
            setUser(record);
          }}
        >
          <EditFilled />
        </Button>
      ),
    },
    {
      title: "Изтрий",
      dataIndex: "delete",
      rowKey: "delete",
      render: (text, record) => (
        <Popconfirm
          icon={
            <QuestionCircleOutlined
              style={{
                color: "red",
              }}
            />
          }
          title="Сигурен ли сте?"
          onConfirm={() => dispatch(deleteUser(record))}
          okText="Да"
          cancelText="Не"
        >
          <Button danger>
            <DeleteFilled />
          </Button>
        </Popconfirm>
      ),
    },
  ];

  const searchedUsers = users.filter((user) => {
    const firstNameMatch = user.firstName
      .toLowerCase()
      .includes(searchValue.toLowerCase());
    const lastNameMatch = user.lastName
      .toLowerCase()
      .includes(searchValue.toLowerCase());

    // Check if any of the organizations have a matching name
    const organizationMatch = user.organizations.some(
      (org) =>
        org.isChecked &&
        org.name.toLowerCase().includes(searchValue.toLowerCase())
    );

    // Return true if any of the conditions are met
    return firstNameMatch || lastNameMatch || organizationMatch;
  });

  return (
    <>
      <AdminUsersEditModal
        user={user}
        openAdminUserEditModal={openAdminUserEditModal}
        setOpenAdminUserEditModal={setOpenAdminUserEditModal}
      />
      <PageHeader text="Потребители" />
      <AdminUsersSearchInput sendSearchValue={saveSearchValue} />
      <Table
        rowKey="id"
        dataSource={searchedUsers}
        className="admin-users-table"
        columns={columns}
        loading={users?.length === 0}
        pagination={{
          defaultPageSize: 100,
          showSizeChanger: true,
          pageSizeOptions: ["100", "150", "200", "250", "300"],
        }}
      />
    </>
  );
};

export default Users;
